module.exports = __webpack_public_path__ + "img/CheckImage.844a1799.png";